import { jwtDecode } from 'jwt-decode';

export const superAdminValidation = (token: string | null) => {
  if (token) {
    const decodedToken: any = jwtDecode(token ? token : '');
    const roles = decodedToken.roles as string[];
    return roles.includes('SUPER_ADMIN');
  }
};

export const appAccountValidation = (token: string | null) => {
  if (token) {
    const decodedToken: any = jwtDecode(token ? token : '');
    const roles = decodedToken.roles as string[];
    return roles.includes('APP_ACCOUNT');
  }
};

export const swmAccountValidation = (token: string | null) => {
  if (token) {
    const decodedToken: any = jwtDecode(token ? token : '');
    const roles = decodedToken.roles as string[];
    return roles.includes('SWM_SENDER');
  }
};